
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useNewsList } from '@/modules/news/model/list';
import { ROUTE_NAME_NEWS } from '@/modules/news/router';
import { NewsOptions } from '@/modules/news/model/mixins';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_NEWS.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, query, fetchList, actions } = useNewsList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                {
                    type: TableColumnType.Image,
                    label: 'Thumbnail',
                    imageKey: 'thumbnail',
                    statusKey: 'thumbnailStatus'
                },
                { type: TableColumnType.Option, label: 'Status', key: 'status', options: NewsOptions.Status },
                { type: TableColumnType.DateTime, label: 'Created At', key: 'createdAt' },
                { type: TableColumnType.DateTime, label: 'Updated At', key: 'updatedAt' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-pen-square',
                        theme: 'info',
                        tooltip: 'Edit content',
                        to: { name: ROUTE_NAME_NEWS.CONTENT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_NEWS.EDIT, params: { id: row.id } }
                    }),
                    canShow: (row: any) => row.canEdit,
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Translate',
                        to: { name: ROUTE_NAME_NEWS.TRANSLATE, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-copy',
                        theme: 'info',
                        tooltip: 'Clone',
                        to: { name: ROUTE_NAME_NEWS.CLONE, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-play',
                        theme: 'success',
                        tooltip: 'Enable',
                        onclick: () => actions.enable(row.id)
                    }),
                    canShow: (row: any) => row.canEnable
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-stop',
                        theme: 'warning',
                        tooltip: 'Disable',
                        onclick: () => actions.disable(row.id)
                    }),
                    canShow: (row: any) => row.canDisable
                },

                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList, ROUTE_NAME_NEWS };
    }
});
